import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=613b52be"
import script from "./RuleModal.ts?vue&type=script&lang=ts&external"
export * from "./RuleModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports